import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateServiceOrderModel,
  DeleteServiceOrderModel,
  SearchServiceOrderModel,
} from '../../../models/service-order.model'

@Injectable({
  providedIn: 'root',
})
export class ServiceOrderService {
  private baseUrl = environment.baseUrl
  private resource = 'OrdemServico'
  private resourceItineraries = 'OrdemServicoItinerario'

  constructor(private httpClient: HttpClient) {}

  public createServiceOrder(
    model: CreateServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editServiceOrder(
    model: any,
    // model: EditServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteServiceOrder(
    model: DeleteServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedServiceOrder(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedServiceOrderOrdenation(
    page: number,
    rows = 15,
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/listpaginated-ordenacao?pageNumber=${page}&pageSize=${rows}&osId=${id}`,
    )
  }

  public listServiceOrder(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getServiceOrderbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedServiceOrder(
    page: number,
    rows = 15,
    model: SearchServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public createServiceOrderItinerary(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/create`,
      model,
    )
  }

  public editServiceOrderItinerary(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/edit`,
      model,
    )
  }

  public editServiceOrderEditStatus(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit-status`,
      model,
    )
  }

  public removeServiceOrderItinerary(
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/remove/${id}`,
      id,
    )
  }

  public getServiceOrderItineraryStopbyId(
    id: any,
    rows = 15,
    page: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/OrdemServico-paginated/parada/${id}%20?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public getServiceOrderParents(
    idOS: string,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/ordem-servico?pageNumber=${page}&pageSize=${rows}`,
      { ordemServicoId: idOS },
    )
  }

  public importDataServiceOrderParents(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/import/ordens-servico`,
      model,
    )
  }

  public searchPagedServiceOrderByProposal(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/proposta?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
